// UI micro-copy dictionary (DA default, EN fallback).
export const STRINGS = {
  da: {
    nav_home: "Hjem",
    nav_about: "Om mig",
    nav_services: "Ydelser",
    nav_projects: "Projekter",
    nav_techstacks: "Tech Stacks",
    nav_blog: "Viden",
    nav_contact: "Kontakt",
    section_explore: "Naviger",
    section_projects: "Projekter",
    section_stacks: "Tech Stacks",
    cta_talk: "Lad os snakke",
    available: "Ledig for nye projekter",
    all_services: "Alle ydelser",
    all_stacks: "Alle tech stacks",
    all_projects: "Alle projekter",
    read_also: "Læs også",
    related_services: "Relaterede ydelser",
    what_included: "Det får du",
    faq: "Ofte stillede spørgsmål",
    visit: "Besøg",
    role: "Rolle",
    read_article: "Læs artikel",
    read_more: "Læs mere",
    min_read: "min læsetid",
    back_to_blog: "Tilbage til viden",
    view_stack: "Se stack",
    tools_count: "værktøjer",
    view_all_articles: "Se alle artikler",
    newsletter_title: "Følg med i min SEO-viden",
    newsletter_name: "\u201cIf I was X\u201d \u2014 Mini SEO roasts",
    newsletter_text: "På mit LinkedIn-nyhedsbrev \u201cIf I was X\u201d laver jeg mini SEO-roasts: \u201cIf I was [Brand], I'd fix these SEO gaps ASAP.\u201d Korte, konkrete nedslag i rigtige brands' SEO. Connect med mig eller abonnér.",
    newsletter_connect: "Connect på LinkedIn",
    newsletter_subscribe: "Abonnér på nyhedsbrev",
    contact_title: "Lad os styrke din forretning sammen",
    contact_name: "Navn",
    contact_email: "Email",
    contact_company: "Virksomhed (valgfrit)",
    contact_visitors: "Månedlige besøgende (valgfrit)",
    contact_message: "Hvordan kan jeg hjælpe dig?",
    contact_send: "Send besked",
    contact_sending: "Sender...",
    contact_success: "Tak! Din besked er modtaget. Du hører fra mig inden for 24 timer.",
    contact_error: "Noget gik galt. Prøv igen eller skriv til mig på LinkedIn.",
    contact_find: "Her finder du mig",
    contact_reach: "Her fanger du mig",
    footer_tagline: "SEO specialist i Odense. Organisk vækst der kan mærkes på bundlinjen.",
    footer_rights: "Alle rettigheder forbeholdes.",
    not_found: "Siden blev ikke fundet",
    go_home: "Til forsiden",
    lang_label: "Sprog",
    nav_sitemap: "Sitemap",
  },
  en: {
    nav_home: "Home",
    nav_about: "About",
    nav_services: "Services",
    nav_projects: "Projects",
    nav_techstacks: "Tech Stacks",
    nav_blog: "Blog",
    nav_contact: "Contact",
    section_explore: "Navigate",
    section_projects: "Projects",
    section_stacks: "Tech Stacks",
    cta_talk: "Let's talk",
    available: "Available for new projects",
    all_services: "All services",
    all_stacks: "All tech stacks",
    all_projects: "All projects",
    read_also: "Read also",
    related_services: "Related services",
    what_included: "What you get",
    faq: "Frequently asked questions",
    visit: "Visit",
    role: "Role",
    read_article: "Read article",
    read_more: "Read more",
    min_read: "min read",
    back_to_blog: "Back to blog",
    view_stack: "View stack",
    tools_count: "tools",
    view_all_articles: "View all articles",
    newsletter_title: "Follow my SEO insights",
    newsletter_name: "\u201cIf I was X\u201d \u2014 Mini SEO roasts",
    newsletter_text: "On my LinkedIn newsletter \u201cIf I was X\u201d I do mini SEO roasts: \u201cIf I was [Brand], I'd fix these SEO gaps ASAP.\u201d Short, concrete takes on real brands' SEO. Connect with me or subscribe.",
    newsletter_connect: "Connect on LinkedIn",
    newsletter_subscribe: "Subscribe to newsletter",
    contact_title: "Let's strengthen your business together",
    contact_name: "Name",
    contact_email: "Email",
    contact_company: "Company (optional)",
    contact_visitors: "Monthly visitors (optional)",
    contact_message: "How can I help you?",
    contact_send: "Send message",
    contact_sending: "Sending...",
    contact_success: "Thank you! Your message has been received. You'll hear from me within 24 hours.",
    contact_error: "Something went wrong. Try again or reach me on LinkedIn.",
    contact_find: "Where to find me",
    contact_reach: "How to reach me",
    footer_tagline: "SEO specialist in Odense. Organic growth that shows on the bottom line.",
    footer_rights: "All rights reserved.",
    not_found: "Page not found",
    go_home: "Back home",
    lang_label: "Language",
    nav_sitemap: "Sitemap",
  },
};

export function t(lang, key) {
  return (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.da[key] || key;
}
